import {AfterViewInit, Component, Input, OnInit, Output, TemplateRef, ViewChild} from '@angular/core';
import {BsModalRef, BsModalService} from 'ngx-bootstrap';
import {Observable} from 'rxjs/Observable';
import {MapDrawing} from './drawing/drawing';
import * as ol from 'openlayers';
import {ChannelService} from './channel.service';
import {UIRouter} from '@uirouter/angular';
import {HttpClient} from '@angular/common/http';
import {Channel} from './channel.model';
import {ChannelMarker} from './drawing/channel-marker';
import {EventEmitter} from '@angular/core';
import {DrawingService} from '../drawing/drawing.service';
import {FileService} from '../file/file.service';
import {Drawing} from '../drawing/drawing.model';

@Component({
  selector: 'app-channel-drawing',
  templateUrl: 'channel-drawing.component.html'
})
export class ChannelDrawingComponent implements OnInit, AfterViewInit {
  private drawing: MapDrawing;
  private coordinateValue: [number, number];
  private buildingId: string;
  private floorId: string;

  @ViewChild('drawingModal') template: TemplateRef<any>;
  private modalRef: BsModalRef;

  public initialized: boolean = false;
  public selectedChannel: ChannelMarker;
  public drawingEnabled: boolean;
  public isSelected: boolean;
  public channels: Array<Channel> = [];
  public pickedChannelId: string;
  public coordinateDraft: [number, number];
  public isDrawingAvailable: boolean = true;

  constructor(
    protected router: UIRouter,
    private channelService: ChannelService,
    private drawingService: DrawingService,
    private fileService: FileService,
    private http: HttpClient,
    private modalService: BsModalService
  ) {}

  @Input() viewMode: boolean = false;
  @Input() assignmentType: string;

  @Output() buildingChange = new EventEmitter();
  set building(value: string) {
    this.buildingId = value;
  }

  @Input()
  get building(): string {
    return this.buildingId;
  }

  @Output() floorChange = new EventEmitter();
  set floor(value: string) {
    this.floorId = value;
  }

  @Input()
  get floor(): string {
    return this.floorId;
  }

  @Output() coordinateChange = new EventEmitter();
  set coordinate(value: [number, number]) {
    if (value) {
      this.coordinateValue = [Math.round(value[0]), Math.round(value[1])];
      this.coordinateChange.emit(this.coordinateValue);
    }
  }

  @Input()
  get coordinate(): [number, number] {
    return this.coordinateValue;
  }

  @Input() private location: string;

  ngOnInit(): void {
    this.initialized = true;
  }

  ngAfterViewInit(): void {
  }

  private loadDrawing(): Observable<boolean> {

    return new Observable<boolean>((observer) => {
      this.drawingService.setRoutePrefix(`building/${this.buildingId}/floor/${this.floorId}`);

      this.drawingService.getAll().subscribe((drawings: Drawing[]) => {
        const drawing = drawings[0];
        if(drawing !== undefined) {
          const fileSrc = this.fileService.getLinkById(drawing.fileId);
          drawing.setFileSrc(fileSrc);
          observer.next(true);
          this.isDrawingAvailable = true;

          this.http.get(drawing.fileSrc, { responseType: 'blob' }).subscribe( (data: Blob) => {
            const objectUrl = URL.createObjectURL(data);
            const img: HTMLImageElement = document.createElement('img');
            img.src = objectUrl;
            img.onload = () => {
              this.initDrawing(objectUrl, img.width, img.height);
            };
          });
        } else {
          this.isDrawingAvailable = false;
          observer.next(false);
        }
      });
    });
  }

  initDrawing(objectUrl: string, width: number, height: number) {
    this.drawing = new MapDrawing({
      target: 'map',
      controls: [],
      renderer: 'canvas',
      interactions: ol.interaction.defaults({altShiftDragRotate: false, pinchRotate: false}),
      viewMode: this.viewMode
    }, width, height);

    if(!this.viewMode) {
      this.drawing.on(MapDrawing.CHANNEL_SELECTED, this.onChannelSelected, this);
      this.drawing.on(MapDrawing.COORDINATE_SELECTED, this.onCoordinateSelected, this);
    }

    this.channelService.getAll().subscribe((channels: Channel[]) => {
      this.channels = channels.filter((channel: Channel) => {
        const isCurrentChannel = (channel.id === this.router.stateService.params.channelId);
        const isOnSameFloor = (channel.floorId === this.floorId);
        const hasCoordinate = (!!channel.coordinate && channel.coordinate[0] !== 0 && channel.coordinate[1] !== 0);
        return (!isCurrentChannel && isOnSameFloor && hasCoordinate);
      });
      this.drawing.loadChannels(this.channels);
    });

    this.drawing.loadImage(objectUrl);

    if(this.coordinate) {
      this.drawing.setHighlightedChannelPosition(this.coordinate, this.location);
    }
  }

  enableDrawing(): void {
    this.loadDrawing().subscribe((loaded: boolean) => {
      this.modalRef = this.modalService.show(this.template, 'modal-lg');
    });
  }

  onChannelSelected(event: CustomEvent): void {
    this.selectedChannel = event.detail;
  }

  onCoordinateSelected(event: CustomEvent): void {
    // this.coordinate = event.detail;
    this.coordinateDraft = event.detail;
  }

  onChannelPicked(): void {
    if(this.pickedChannelId !== '') {
      for(let i = 0; i < this.channels.length; i++) {
        if(this.channels[i].id === this.pickedChannelId) {
          this.drawing.applyHighlightedChannelPosition(this.channels[i].coordinate);
          this.coordinateDraft = this.channels[i].coordinate;
          break;
        }
      }
    }
  }

  groupSelectedChannel(): void {
    this.drawing.applyHighlightedChannelPosition(this.selectedChannel.channel.coordinate);
    this.coordinateDraft = [this.selectedChannel.x * MapDrawing.COORDINATE_SCALE, this.selectedChannel.y * MapDrawing.COORDINATE_SCALE];
    this.selectedChannel = null;
  }

  deselectChannel(): void {
    this.selectedChannel = null;
  }

  saveAndClose(): void {
    this.coordinate = this.coordinateDraft;
    this.coordinateDraft = undefined;
    this.drawingEnabled = false;
    this.modalRef.hide();
  }

  discardAndClose(): void {
    this.coordinateDraft = undefined;
    this.drawingEnabled = false;
    this.modalRef.hide();
  }

}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/channel/channel-drawing.component.ts